var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.03734 7.26409C7.98169 7.26409 8.74723 6.50034 8.74723 5.5582V2.99935C8.74723 2.05721 7.98169 1.29346 7.03734 1.29346H2.76262C1.81828 1.29346 1.05273 2.05721 1.05273 2.99935V8.33028C1.05273 8.44805 1.14843 8.54352 1.26647 8.54352C1.32295 8.54319 1.3769 8.52012 1.41609 8.47955L2.27103 7.6266C2.51654 7.38812 2.8475 7.25758 3.19009 7.26409H7.03734ZM1.90768 6.83762V2.99935C1.90768 2.52828 2.29045 2.14641 2.76262 2.14641H7.03734C7.50951 2.14641 7.89229 2.52828 7.89229 2.99935V5.5582C7.89229 6.02927 7.50951 6.41115 7.03734 6.41115H3.19009C2.72763 6.41115 2.27765 6.56079 1.90768 6.83762ZM9.60217 2.99935V6.41115C9.60217 7.35329 8.83663 8.11704 7.89229 8.11704H2.76262C2.76262 8.58811 3.14539 8.96999 3.61757 8.96999H8.31976C8.66124 8.96916 8.98896 9.10423 9.23027 9.34529L10.0852 10.1982C10.1244 10.2388 10.1784 10.2619 10.2348 10.2622C10.3529 10.2622 10.4486 10.1667 10.4486 10.049V3.8523C10.4486 3.38454 10.071 3.00403 9.60217 2.99935Z",
    fill: "#006E7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.1181d99b003a48aad484c7884daaef2b.svg";
export { ForwardRef as ReactComponent };